<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="会员卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['cardId']" placeholder="请输入会员卡号"></a-input>
        </a-form-item>
        <a-form-item label="会员姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['memberName']" placeholder="请输入会员姓名"></a-input>
        </a-form-item>
        <a-form-item label="会员手机号码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['memberPhone']" placeholder="请输入会员手机号码"></a-input>
        </a-form-item>
        <a-form-item label="可用余额" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['availableBalance']" placeholder="请输入可用余额" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="可用积分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['availableScore']" placeholder="请输入可用积分" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="会员级别" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['memberLevel']" placeholder="请输入会员级别"></a-input>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  
  export default {
    name: "MemberInfoAssetsModal",
    components: { 
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/member/memberInfoAssets/add",
          edit: "/member/memberInfoAssets/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'cardId','memberName','memberPhone','availableBalance','availableScore','memberLevel'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'cardId','memberName','memberPhone','availableBalance','availableScore','memberLevel'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>